import { render, staticRenderFns } from "./SeminarTicket.vue?vue&type=template&id=04e28d0e&scoped=true&"
import script from "./SeminarTicket.vue?vue&type=script&lang=js&"
export * from "./SeminarTicket.vue?vue&type=script&lang=js&"
import style0 from "./SeminarTicket.vue?vue&type=style&index=0&id=04e28d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e28d0e",
  null
  
)

export default component.exports